import React, { Fragment } from 'react'

import { connect } from 'react-redux'

import { Konfirm_MCU } from '../../../../../../Store/Actions/Job.Action'

import { FormControl, InputLabel, Select, TextField, Button } from '@mui/material'

import DetailMCU from './DetailMCU'

class KonfirmMCU extends React.Component {
    state = {
        Status: '',
        Keterangan: ''
    }

    onChangeField = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    formOnSubmit = (e) => {
        e.preventDefault()

        const JobActionId = this.props.JobActionId
        const AccountActionId = this.props.AccountActionId

        this.props.Konfirm_MCU(JobActionId, AccountActionId, this.state.Status, this.state.Keterangan)
    }

    render() {

        const {
            Status,
            Keterangan,
        } = this.state

        const OpStatus = ['Accept', 'Reject']

        const st_textfield_non = { marginTop: '10px', marginBottom: '10px', width: '100%' }

        return (
            <Fragment>
                <DetailMCU />
                <form
                    onSubmit={this.formOnSubmit}
                >

                    <FormControl style={st_textfield_non} variant="filled" required >
                        <InputLabel shrink >Status</InputLabel>
                        <Select style={{ backgroundColor: 'white' }} native onChange={(e) => this.onChangeField(e)} label="Status" name='Status' value={Status}  >
                            <option value="" disabled> -- select an option -- </option>
                            {OpStatus.map((option, index) =>
                                <option key={`OpStatus_${index}`} value={option}>{option}</option>
                            )}
                        </Select>
                    </FormControl>

                    <TextField
                        style={st_textfield_non}
                        variant='outlined'
                        type='text'
                        label='Keterangan'
                        name='Keterangan'
                        value={Keterangan}
                        onChange={this.onChangeField}
                    />

                    <center>
                        <Button
                            variant='contained'
                            style={{ margin: '10% 0 5% 0', width: '60%' }}
                            type='submit'
                        >
                            Submit
                        </Button>
                    </center>
                </form>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    JobActionId: state.Job.JobActionId,
    AccountActionId: state.Account.AccountActionId,
})

export default connect(mapStateToProps, { Konfirm_MCU })(KonfirmMCU)